'use client';

import type { PropsWithChildren } from 'react';
import type { Collection } from '@/app/actions/collection';
import type { ConclusionType } from '~/model/ConclusionType';
import type { InteractionType } from '~/model/InteractionType';
import type { QuestionReconstructedType, QuestionType } from '~/model/QuestionType';
import type { SectionType } from '~/model/SectionType';
import { createContext, useContext } from 'react';
import { useForm } from '@/app/hooks/useForm';

const FormContext = createContext<ReturnType<typeof useForm> | undefined>(undefined);

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error(
      'useFormContext must be called within FormContext',
    );
  }
  return context;
};

export const FormProvider = ({
  children,
  interaction,
  questions,
  sections,
  conclusions,
}: PropsWithChildren<{
  interaction: InteractionType;
  questions?: Array<QuestionType | QuestionReconstructedType>;
  sections?: Array<SectionType>;
  conclusions?: Collection<ConclusionType>;
}>) => {
  const value = useForm({ interaction, questions, sections, conclusions });

  return (
    <FormContext.Provider value={value}>
      {children}
    </FormContext.Provider>
  );
};
